export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_POST_PAGE_SIZE = 50;
export const pageSizeOptions: string[] = [`${DEFAULT_PAGE_SIZE}`, '20', '50', '100'];
export const mentionsPageSizeOptions: string[] = [`${DEFAULT_PAGE_SIZE}`, '50', '100'];

export const getMentionsPageSize = (pageSize?: number | string | null): number => {
  const normalizedPageSize = Number(pageSize);
  return mentionsPageSizeOptions.includes(`${normalizedPageSize}`)
    ? normalizedPageSize
    : DEFAULT_PAGE_SIZE;
};
